const loaderSize = {
  extraLarge: 22,
  large: 14,
  medium: 14,
  small: 8,
  extraSmall: 6,
};

export default loaderSize;



// WEBPACK FOOTER //
// ./packages/marvel-ui-loader/sizes.spec.js